/**
 * 小数点以下の0を削除する
 * @param {*} value 
 * @returns 
 */
export const trimDecimalZero = value => {
  if (!value) return null
  const str = value.toString()
  // 小数点がない場合はそのまま返す
  if (!str.includes('.')) return str
  // 末尾の0を削除し、小数点だけが残る場合は小数点も削除
  return str.replace(/\.?0+$/, '')
}